/* eslint-disable jsx-a11y/alt-text */
import React, {useEffect, useState } from 'react'
import './Entete.css'
import { useCookies } from 'react-cookie'
import { Link, useLocation, useOutletContext } from "react-router-dom";
import { AppBar, Avatar, Box, Container, Divider, IconButton, Menu, MenuItem, Toolbar, Typography } from '@mui/material'
import { Enseigne, Magasin } from '../../Models/Magasin/MagasinModels'
import { URL_MIDIS } from '../../Setting'
import { EnseigneService } from '../../Services/Magasin/EnseigneService';
import MenuIcon from '@mui/icons-material/Menu';

export interface propsEntete{
  mobileOpen:boolean, setMobileOpen:React.Dispatch<React.SetStateAction<boolean>>,
  isClosing:boolean, setIsClosing:React.Dispatch<React.SetStateAction<boolean>>
}

/**
 * Composant d'en-tête de l'application.
 *
 * Ce composant affiche un en-tête avec des options de menu et des boutons de déconnexion.
 * Il permet également de basculer entre les affichages de l'interface et de gérer l'état de connexion.
 *
 * @param props - Les propriétés du composant.
 * @param props.connecter - Indique si l'utilisateur est connecté.
 * @param props.setInterfaceNumber - Fonction pour définir le numéro de l'interface actuelle.
 * @param props.setConnecter - Fonction pour définir l'état de connexion de l'utilisateur.
 * @param props.interfaceNumber - Le numéro de l'interface actuellement affichée.
 * @param props.setSwitchAffichage - Fonction pour définir l'état d'affichage du composant.
 * @returns Le composant `Entete`.
 */
export function Entete(props:propsEntete) {

  const {mobileOpen, setMobileOpen, isClosing, setIsClosing}=props

  //attributes
  const [_c, _sc, removeCookie] = useCookies(['token'])
  let location = useLocation(); //utilisation de l'url actuelle pour modifier elements entete
  const [cookies] = useCookies(['token'])
  const [loading, setLoading] = useState<boolean>(true)
  //API attributes
  const token = cookies.token;
  const [magasin, setMagasin] = useState<Magasin>({
    id:0,
    abonnements:[],
    nom:'',
    raison_sociale:'',
    sousGroupes:[],
  })

  // const [enseigne, setEnseigne] = useState<Enseigne>({
  //   id:0,
  //   fichiers:[],
  //   nom:'',
  //   sousGroupes:[],
  // });

  const contextDonnees = useOutletContext<any[]>(); 
  const magasinsContext:Magasin[] = contextDonnees[5];


  /**
   * Gère la déconnexion de l'utilisateur en réinitialisant les propriétés CSS et les états associés.
   */
  const deconnexionCSS = () => {
    document.documentElement.style.setProperty('--interface-width', '25vw')
    document.documentElement.style.setProperty(
      '--interface-width-mobil',
      '85vw',
    )
    document.documentElement.style.setProperty(
      '--interface-margin-top-mobil',
      '2vh',
    )
    document.documentElement.style.setProperty(
      '--interface-margin-bot-mobil',
      '0%',
    )
    document.documentElement.style.setProperty(
      '--interface-border-radius',
      '10px',
    )
  }

  //use effect to initialize numeroClient
  useEffect(()=>{

    async function infoClient(){
      if(token && !(location.pathname.split("/")[1] === 'admin') && magasinsContext.length>0){
        // const resultClient = await MagasinService().getMagasinsUtilisateur(token);
        const magHyper = magasinsContext.find(mag=>mag.typeMagasin?.type==='Hyper');
        if(magHyper){
          setMagasin(magHyper)
        }else{
          setMagasin(magasinsContext[0]);
        }
        // if(magasinsContext[0].typeMagasin?.enseigne){
        //   const enseigneResult = await EnseigneService().getMinimalEnseigneFromIDToPromiseToAnything(magasinsContext[0].typeMagasin?.enseigne.id, token);
        //   setEnseigne(enseigneResult)
        // }
      }
      setLoading(false);
    }

    infoClient();
    return ()=>{

    }
  }, [location.pathname, magasinsContext, token]);

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  // TEST gestion drawer
  const handleDrawerToggle = () => {
      if (!isClosing) {setMobileOpen(!mobileOpen);}
  };

  return (

    <AppBar sx={{backgroundColor:'white'}} position="static">
      <Container style={{maxWidth:'unset'}}>
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleDrawerToggle}
              // color="inherit"
            >
              <MenuIcon />
            </IconButton>
          </Box>

          {/* version desktop */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
            {
              (location.pathname.split("/")[1] === 'admin') ? (
                <Link style={{textDecoration:'none'}} to={'/admin'}>
                  <div className='midis-com-container'>
                    <p className='Entete-midis'>midis</p>
                    <p className='Entete-com'>com</p>
                  </div>
                </Link>
              ) : (
                <Link style={{textDecoration:'none'}} to={'/accueil'}>
                  <div className='midis-com-container'>
                    <p className='Entete-midis'>midis</p>
                    <p className='Entete-com'>com</p>
                  </div>
                </Link>
              )
            }
          </Box>

          {/* version mobile */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
            {
              (location.pathname.split("/")[1] === 'admin') ? (
                <Link style={{textDecoration:'none'}} to={'/admin'}>
                  <div className='midis-com-container'>
                    <p className='Entete-midis'>midis</p>
                    <p className='Entete-com'>com</p>
                  </div>
                </Link>
              ) : (
                <Link style={{textDecoration:'none'}} to={'/accueil'}>
                  <div className='midis-com-container'>
                    <p className='Entete-midis'>midis</p>
                    <p className='Entete-com'>com</p>
                  </div>
                </Link>
              )
            }
          </Box>

          <Box sx={{ flexGrow: 1 }} />

          {/* version desktop */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }}>
            {(location.pathname.split("/")[1] === 'admin') || (location.pathname.split("/")[1] === 'accueil') || (location.pathname.split("/")[1] === 'monCompte') ? (
              <div className='account-container'>
                {magasin.typeMagasin && magasin.typeMagasin.fichiers.length>0 && !(location.pathname.split("/")[1] === 'admin') && <img style={{margin:1, width:100}} src={URL_MIDIS+magasin.typeMagasin.fichiers[0].chemin} alt='logo'/>}
                {
                  (!loading)?
                  <p className='Entete-mon-compte-nom'>{magasin.nom.toUpperCase()}</p>
                  :
                  <>
                      <p className='Entete-mon-compte-nom'>Chargement...</p>
                  </>
                }
              </div>
            ) : null}
          </Box>
          
          {/* version mobile */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
            {(location.pathname.split("/")[1] === 'admin') || (location.pathname.split("/")[1] === 'accueil') || (location.pathname.split("/")[1] === 'monCompte') ? (
              <div className='account-container'>
                {magasin.typeMagasin && magasin.typeMagasin.fichiers.length>0 && !(location.pathname.split("/")[1] === 'admin') && <img style={{margin:1, width:100}} src={URL_MIDIS+magasin.typeMagasin.fichiers[0].chemin} alt='logo'/>}
                {
                  (!loading)?
                  <p className='Entete-mon-compte-nom'>{magasin.nom.toUpperCase()}</p>
                  :
                  <>
                      <p className='Entete-mon-compte-nom'>Chargement...</p>
                  </>
                }
              </div>
            ) : null}
          </Box>

          {
            !(location.pathname.split("/")[1] === 'login') &&
            <Box sx={{ flexGrow: 0 }}>
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" />
              </IconButton>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {
                  !(location.pathname.split("/")[1] === 'admin') &&
                  
                  <>
                    {
                      magasinsContext.map((mag,index)=>(
                        <MenuItem key={index} selected={false} sx={{pointerEvents:'none'}}>
                          <Typography sx={{ textAlign: 'center' }}>
                            {
                              (!loading)?
                                <>{mag.typeMagasin && mag.typeMagasin.fichiers.length>0 ? <div style={{display:'flex'}}><img style={{width:'100%', maxWidth:'50px', marginRight:'8px'}} src={`${URL_MIDIS+mag.typeMagasin.fichiers[0].chemin}`}></img> {mag.nom.toUpperCase()}</div> : mag.nom.toUpperCase()}</>
                              :
                                'Chargement...'
                            }
                          </Typography>
                        </MenuItem>
                      ))
                    }
                    <Divider/>
                    <Link style={{textDecoration:'none', color:'black'}} to='/monCompte'>
                      <MenuItem onClick={handleCloseUserMenu}>
                        <Typography sx={{ textAlign: 'center' }}>
                          {"Mon Compte"}
                        </Typography>
                      </MenuItem>
                    </Link>
                  </>
                }
                <Link style={{textDecoration:'none', color:'black'}} to="/login">
                  <MenuItem onClick={()=>{handleCloseUserMenu(); removeCookie('token', {path:'/'}); deconnexionCSS()}}>
                    <Typography sx={{ textAlign: 'center' }}>
                      {"Déconnexion"}
                    </Typography>
                  </MenuItem>
                </Link>
              </Menu>
            </Box>
          }

        </Toolbar>
      </Container>
    </AppBar>

    // <div className='Entete'>
    //   {
    //     (location.pathname.split("/")[1] === 'admin') ? (
    //       <Link style={{textDecoration:'none'}} to={'/admin'}>
    //         <div className='midis-com-container'>
    //           <p className='Entete-midis'>midis</p>
    //           <p className='Entete-com'>com</p>
    //         </div>
    //       </Link>
    //     ) : (
    //       <Link style={{textDecoration:'none'}} to={'/accueil'}>
    //         <div className='midis-com-container'>
    //           <p className='Entete-midis'>midis</p>
    //           <p className='Entete-com'>com</p>
    //         </div>
    //       </Link>
    //     )
    //   }
    //   {(location.pathname.split("/")[1] === 'admin') || (location.pathname.split("/")[1] === 'accueil') || (location.pathname.split("/")[1] === 'monCompte') ? (
    //     <div className='account-container'>
    //       {enseigne.fichiers.length>0 && !(location.pathname.split("/")[1] === 'admin') && <img style={{margin:1, maxWidth:100}} src={URL_MIDIS+enseigne.fichiers[0].chemin} alt='logo'/>}
    //       {
    //         (!(location.pathname.split("/")[1] === 'admin'))
    //         ?
    //         <Link style={{textDecoration:'none'}} to='/monCompte'>
    //           <div
    //             className='Entete-mon-compte'
    //             onMouseEnter={() => setMonCompteHovered(true)}
    //             onMouseLeave={() => setMonCompteHovered(false)}
    //           >
    //             {
    //               (!loading)?
    //               <p className='Entete-mon-compte-nom'>{magasin.nom.toUpperCase()}</p>
    //               :
    //               <>
    //                   <p className='Entete-mon-compte-nom'>Chargement...</p>
    //               </>
    //             }
    //             <FontAwesomeIcon
    //               icon={faUser}
    //               style={monCompteHovered ? { color: '#7984ba' } : {}}
    //             />
    //             <div>
    //               <p className='TextCacheMobil'>Mon compte</p>
    //             </div>
    //           </div>
    //         </Link>
    //         :
    //         null
    //       }
    //       <div className='Entete-deconnection-area'>
    //         <Link to="/login">
    //           <Button sx={{fontSize:11, backgroundColor:'var(--violet)'}} variant="contained" color='primary' 
    //           onClick={()=>{removeCookie('token', {path:'/'}); deconnexionCSS()}}>Déconnexion</Button>
    //         </Link>
    //       </div>
    //       <div>
    //         <FontAwesomeIcon
    //           icon={faBars}
    //           className='TextCachePc'
    //           onClick={handleSwitchMenu}
    //         />
    //       </div>
    //     </div>
    //   ) : null}
    // </div>
  )
}